var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "19px",
    viewBox: "0 0 23 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "530F8DF0-FBCA-4CAD-8DDF-A30CAA22F11A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Footer-Feedback-CTA",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.0S_FORD_EU_Ecommerce_Footer_Comment-Card-CTA",
    transform: "translate(-32.000000, -424.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(33.000000, 420.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ico_Comment",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,-0.75 L3,-0.75 C0.928932188,-0.75 -0.75,0.928932188 -0.75,3 L-0.75,11 L-0.744801991,11.1991586 C-0.641273745,13.1776389 0.995740827,14.75 3,14.75 L16.689,14.75 L18.7625631,16.8232233 C19.0907518,17.151412 19.5358711,17.3357864 20,17.3357864 C20.9664983,17.3357864 21.75,16.5522847 21.75,15.5857864 L21.75,3 C21.75,0.928932188 20.0710678,-0.75 18,-0.75 Z M18,0.75 C19.2426407,0.75 20.25,1.75735931 20.25,3 L20.25,15.5857864 C20.25,15.7238576 20.1380712,15.8357864 20,15.8357864 C19.9336959,15.8357864 19.8701074,15.8094472 19.8232233,15.7625631 L17.3106602,13.25 L3,13.25 C1.75735931,13.25 0.75,12.2426407 0.75,11 L0.75,3 C0.75,1.75735931 1.75735931,0.75 3,0.75 L18,0.75 Z",
    id: "Path",
    fill: "#102B4E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,6.77928599 L3.72454486,6.77928599 C3.3103313,6.77928599 2.97454486,7.11507243 2.97454486,7.52928599 C2.97454486,7.94349955 3.3103313,8.27928599 3.72454486,8.27928599 L17,8.27928599 C17.4142136,8.27928599 17.75,7.94349955 17.75,7.52928599 C17.75,7.11507243 17.4142136,6.77928599 17,6.77928599 Z",
    id: "Path",
    fill: "#00095B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,3.77928599 L3.72454486,3.77928599 C3.3103313,3.77928599 2.97454486,4.11507243 2.97454486,4.52928599 C2.97454486,4.94349955 3.3103313,5.27928599 3.72454486,5.27928599 L17,5.27928599 C17.4142136,5.27928599 17.75,4.94349955 17.75,4.52928599 C17.75,4.11507243 17.4142136,3.77928599 17,3.77928599 Z",
    id: "Path",
    fill: "#00095B"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.fdee073f8155a27a3b26706f3710cfa8.svg";
export { ForwardRef as ReactComponent };